import axios from 'axios';

export const STORAGE_BASE_URL = import.meta.env.MODE === 'production'
  ? 'https://www.ispradius.com.tr'
  : (import.meta.env.VITE_STORAGE_URL || 'http://localhost:8000');

const adminApi = axios.create({
  baseURL: import.meta.env.MODE === 'production' 
    ? 'https://www.ispradius.com.tr/api/admin'
    : (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/admin'),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token ekle
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - hata yönetimi
adminApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Features API
export const featuresApi = {
  getAll: (params = {}) => adminApi.get('/features', { params }),
  getById: (id) => adminApi.get(`/features/${id}`),
  create: (data) => adminApi.post('/features', data),
  update: (id, data) => adminApi.put(`/features/${id}`, data),
  delete: (id) => adminApi.delete(`/features/${id}`)
};

// Bank Accounts API
export const banksApi = {
  getAll: (params = {}) => adminApi.get('/banks', { params }),
  getById: (id) => adminApi.get(`/banks/${id}`),
  create: (data) => adminApi.post('/banks', data),
  update: (id, data) => adminApi.put(`/banks/${id}`, data),
  delete: (id) => adminApi.delete(`/banks/${id}`)
};

export const bankAccountsApi = {
  getAll: (params = {}) => adminApi.get('/bank-accounts', { params }),
  getById: (id) => adminApi.get(`/bank-accounts/${id}`),
  create: (data) => adminApi.post('/bank-accounts', data),
  update: (id, data) => adminApi.put(`/bank-accounts/${id}`, data),
  delete: (id) => adminApi.delete(`/bank-accounts/${id}`)
};

// Integration Categories API
export const integrationCategoriesApi = {
  getAll: (params = {}) => adminApi.get('/integration-categories', { params }),
  getById: (id) => adminApi.get(`/integration-categories/${id}`),
  create: (data) => adminApi.post('/integration-categories', data),
  update: (id, data) => adminApi.put(`/integration-categories/${id}`, data),
  delete: (id) => adminApi.delete(`/integration-categories/${id}`)
};

// Integration Companies API
export const integrationCompaniesApi = {
  getAll: (params = {}) => adminApi.get('/integration-companies', { params }),
  getById: (id) => adminApi.get(`/integration-companies/${id}`),
  create: (data) => adminApi.post('/integration-companies', data),
  update: (id, data) => adminApi.put(`/integration-companies/${id}`, data),
  delete: (id) => adminApi.delete(`/integration-companies/${id}`)
};

// FAQ Categories API
export const faqCategoriesApi = {
  getAll: (params = {}) => adminApi.get('/faq-categories', { params }),
  getById: (id) => adminApi.get(`/faq-categories/${id}`),
  create: (data) => adminApi.post('/faq-categories', data),
  update: (id, data) => adminApi.put(`/faq-categories/${id}`, data),
  delete: (id) => adminApi.delete(`/faq-categories/${id}`)
};

// FAQ Questions API
export const faqQuestionsApi = {
  getAll: (params = {}) => adminApi.get('/faq-questions', { params }),
  getById: (id) => adminApi.get(`/faq-questions/${id}`),
  create: (data) => adminApi.post('/faq-questions', data),
  update: (id, data) => adminApi.put(`/faq-questions/${id}`, data),
  delete: (id) => adminApi.delete(`/faq-questions/${id}`)
};

// Contact Info API
export const contactInfoApi = {
  getAll: (params = {}) => adminApi.get('/contact-info', { params }),
  getById: (id) => adminApi.get(`/contact-info/${id}`),
  create: (data) => adminApi.post('/contact-info', data),
  update: (id, data) => adminApi.put(`/contact-info/${id}`, data),
  delete: (id) => adminApi.delete(`/contact-info/${id}`),
  updateSortOrder: (data) => adminApi.put('/contact-info/sort', data)
};

// Users API
export const usersApi = {
  getAll: (params = {}) => adminApi.get('/users', { params }),
  getById: (id) => adminApi.get(`/users/${id}`),
  create: (data) => adminApi.post('/users', data),
  update: (id, data) => adminApi.put(`/users/${id}`, data),
  delete: (id) => adminApi.delete(`/users/${id}`)
};

// Client References API
export const clientReferencesApi = {
  getAll: (params = {}) => adminApi.get('/client-references', { params }),
  getById: (id) => adminApi.get(`/client-references/${id}`),
  create: (data) => adminApi.post('/client-references', data),
  update: (id, data) => adminApi.put(`/client-references/${id}`, data),
  delete: (id) => adminApi.delete(`/client-references/${id}`)
};

// Upload API
export const uploadApi = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return adminApi.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  delete: (url) => adminApi.delete('/upload', { data: { url } })
};

export default adminApi;
